module.exports = __webpack_public_path__ + "img/saum_lichtgrau_ral7035.c2c527be.jpg";